import {
  createSlice,
  createEntityAdapter,
  PayloadAction,
  EntityState,
} from '@reduxjs/toolkit';
import { FAQCategory } from 'core/models';
import { ProcessStatus } from 'states';

export const entityAdapter = createEntityAdapter<FAQCategory>({
  selectId: (model) => model.id,
  sortComparer: (a, b) => a.id.localeCompare(b.id),
});

interface FAQState extends EntityState<FAQCategory> {
  status: ProcessStatus;
}

const initialState: FAQState = entityAdapter.getInitialState({
  status: 'idle',
});

const slice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    resetStatus(state) {
      state.status = 'idle';
    },
    list(state) {
      state.status = 'loading';
    },
    listSuccess(state, action: PayloadAction<FAQCategory[]>) {
      entityAdapter.addMany(state, action.payload);
      state.status = 'success';
    },
    listFailure(state) {
      state.status = 'failure';
    },
  },
});

export const actions = slice.actions;
export default slice;
